import React, { ChangeEvent } from 'react';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { IStyle } from 'Styles';
import SelectInput, { IOption } from 'components/input/selectInput';
import { sortingOrder } from '../Contants';

export interface SortSelectorProps {
  sortByValue: string;
  sortOrder: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  changeSorting: () => void;
  disabled: boolean;
}

const options: IOption[] = [
  { title: 'Select', value: 'Select' },
  { title: 'Wells', value: 'wellNumber' },
  { title: 'Drops', value: 'dropNumber' },
  { title: 'Plates', value: 'plateNumber' },
  { title: 'Scores', value: 'scoreOrderNumber' },
];

const screenOptions: IOption[] = [
  { title: 'Select', value: 'Select' },
  { title: 'Wells', value: 'wellNumber' },
  { title: 'Plates', value: 'plateNumber' },
];

const SortSelector = (props: SortSelectorProps) => {
  const { sortByValue, sortOrder, onChange, changeSorting, disabled } = props;
  return (
    <>
      <div id={'exp-finddrop-sortselector-selectinput'} style={styles.selector}>
        <SelectInput
          options={
            window?.location?.pathname.includes('/screen') ? screenOptions : options
          }
          style={{ minHeight: '25px' }}
          value={sortByValue}
          onChange={onChange}
          {...props}
        />
      </div>
      <div id={'exp-finddrop-sortselector-button'} style={styles.float}>
        <RMCustomButton
          iconProps={{
            name:
              sortOrder === sortingOrder.ASCENDING ? 'SortDescending' : 'SortAscending',
            width: '27px',
            height: '22px',
            fill: 'transparent',
          }}
          onClick={changeSorting}
          isDisabled={disabled}
        />
      </div>
    </>
  );
};

const styles: IStyle = {
  selector: {
    float: 'left',
  },
  float: {
    float: 'left',
    marginRight: '1%',
  },
};

export default SortSelector;
